import { appSelectors } from '@appStore/reducers/app'
import { useMemo } from 'react'
import { useAppSelector } from 'shared/hooks'

import { api } from '../api'
import { useCurrentId } from './useCurrentId'

export function useConversationalist() {
	const conversation = useCurrentId()

	const userID = useAppSelector(appSelectors.personIdLi)

	const { data: persons } = api.useParticipantsQuery(conversation, {
		skip: !conversation
	})

	return useMemo(
		() => persons?.find(p => p.entityId !== userID),
		[persons, userID]
	)
}
